<template>
    <div class="container">
        <div class="title">
            <div class="line"></div>
            <p>基础信息</p>
        </div>
        <div class="content">
            <!-- 房屋地址 -->
            <div class="address flex-x mb30">
                <label class="label"
                ><span style="color: red">*</span>房屋地址</label
                >
                <div class="address-input" @click="getShowMap">
                    <input
                        type="text"
                        placeholder="请输入详细地址"
                        readonly
                        v-model="data.oAddress.name"
                    />
                </div>
            </div>
            <!-- 装修情况 -->
            <div class="decorate flex-x mb30" v-if="data.oRenovationInfo.items.length">
                <label class="label"
                ><span
                    style="color: red"
                    v-if="data.oRenovationInfo.is_require === 1"
                >*</span
                >{{ data.oRenovationInfo.name }}</label
                >
                <div class="tag">
                    <div
                        :class="[
                            'tag-item',
                            active(data.oRenovationInfo, item) ? 'active' : '',
                        ]"
                        v-for="(item, index) in data.oRenovationInfo.items"
                        :key="index"
                        @click="tagSelectChange(data.oRenovationInfo, item)"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <!-- 用户性别 -->
            <div class="decorate flex-x mb30" v-if="data.oGenderInfo.items.length">
                <label class="label"
                ><span
                    style="color: red"
                    v-if="data.oGenderInfo.is_require === 1"
                >*</span
                >{{ data.oGenderInfo.name }}</label
                >
                <div class="tag">
                    <div
                        :class="[
                            'tag-item',
                            active(data.oGenderInfo, item) ? 'active' : '',
                        ]"
                        v-for="(item, index) in data.oGenderInfo.items"
                        :key="index"
                        @click="tagSelectChange(data.oGenderInfo, item)"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <!-- 房屋面积 -->
            <div class="area flex-x mb30">
                <label class="label"
                ><span style="color: red">*</span>房屋面积</label
                >
                <div class="area-content">
                    <div class="input-wrap">
                        <input
                            type="text"
                            @input="NumberCheck(0, $event)"
                            name=""
                            v-model="data.nArea"
                        />
                        <span>m²</span>
                    </div>
                    <p>层高</p>
                    <div class="input-wrap">
                        <input
                            type="text"
                            @input="NumberCheck(1,$event)"
                            name=""
                            v-model="data.nFloor"
                        />
                        <span>m</span>
                    </div>
                </div>
            </div>
            <!-- 房屋保温情况 -->
            <h4 class="tips mb30" v-if="data.oExteriorInfo.items.length">房屋保温情况</h4>
            <!-- 外墙保温 oExteriorInfo-->
            <div class="exterior flex-x mb30" v-if="data.oExteriorInfo.items.length">
                <label class="label font-nor"
                ><span
                    style="color: red"
                    v-if="data.oExteriorInfo.is_require === 1"
                >*</span
                >{{ data.oExteriorInfo.name }}</label
                >
                <div class="tag">
                    <div
                        :class="[
                            'tag-item',
                            active(data.oExteriorInfo, item) ? 'active' : '',
                        ]"
                        v-for="(item, index) in data.oExteriorInfo.items"
                        :key="index"
                        @click="tagSelectChange(data.oExteriorInfo, item)"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <!-- 双层隔热窗 oHeatInsulationInfo-->
            <div class="heat-insulation flex-x mb30" v-if="data.oHeatInsulationInfo.items.length">
                <label class="label font-nor"
                ><span
                    style="color: red"
                    v-if="data.oHeatInsulationInfo.is_require === 1"
                >*</span
                >{{ data.oHeatInsulationInfo.name }}</label
                >
                <div class="tag">
                    <div
                        :class="[
                            'tag-item',
                            active(data.oHeatInsulationInfo, item) ? 'active' : '',
                        ]"
                        v-for="(item, index) in data.oHeatInsulationInfo.items"
                        :key="index"
                        @click="tagSelectChange(data.oHeatInsulationInfo, item)"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <!-- 房屋类型 -->
            <div class="room-mode flex-x mb30" v-if="data.oPropertyTypeInfo.items.length">
                <label class="label"
                ><span
                    style="color: red"
                    v-if="data.oPropertyTypeInfo.is_require === 1"
                >*</span
                >{{ data.oPropertyTypeInfo.name }}</label
                >
                <div class="tag">
                    <div
                        :class="[
                            'tag-item',
                            active(data.oPropertyTypeInfo, item) ? 'active' : '',
                        ]"
                        v-for="(item, index) in data.oPropertyTypeInfo.items"
                        :key="index"
                        @click="tagSelectChange(data.oPropertyTypeInfo, item)"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <!-- 户型概况 -->
            <div class="house-type mb30" v-show="data.nHuoseType">
                <label class="label"
                ><span style="color: red">*</span
                >{{ data.oHouseTypeInfo.name }}</label
                >
                <div class="wrap">
                    <div class="scorll-wrap">
                        <ul v-if="data.oHouseTypeInfo.tabList.length > 1">
                            <li
                                :class="[
                                    data.oHouseTypeInfo.activeIndex === index
                                        ? 'tab-active'
                                        : '',
                                    data.oHouseTypeInfo.tabList.length <= 3
                                        ? 'tab_flex'
                                        : 'tab_noflex',
                                ]"
                                v-for="(item, index) in data.oHouseTypeInfo.tabList"
                                :key="index"
                                @click="tabSwitch(index)"
                            >
                                {{ item.room | roomNumber }}
                            </li>
                        </ul>
                    </div>

                    <div class="tab-content">
                        <div
                            class="cell"
                            v-for="(item, index) in arrTabContent"
                            :key="index"
                        >
                            <div class="cell-head">{{ item.name }}</div>
                            <div class="cell-center">
                                <div
                                    :class="[
                                        'cell-item',
                                        tagItem.common_use === 0
                                            ? 'disable'
                                            : '',
                                    ]"
                                    v-for="(tagItem, tagIndex) in item.tags"
                                    :key="tagIndex"
                                >
                                    {{
                                        tagItem.name
                                    }}{{
                                        tagItem.isNumber === 1
                                            ? tagItem.number
                                            : ""
                                    }}
                                </div>
                            </div>
                            <div
                                class="cell-footer"
                                @click="editHouseTypeInfo()"
                            ></div>
                        </div>
                    </div>
                </div>
                <div
                    class="add-btn"
                    @click.stop="editFloorContent()"
                    v-show="arrTabContent.length === 0"
                ></div>
                <div
                    class="add-btn"
                    @click.stop="addFloor()"
                    v-show="data.nHuoseType !== 1"
                >
                    <p>编辑楼层</p>
                </div>
                <div
                    class="del-btn"
                    @click.stop="delFloor()"
                    v-show="data.nHuoseType !== 1"
                >
                    <p>删除楼层</p>
                </div>
                <!-- <div class="add-btn" @click="selectNoOftenTag()"><p>选择低频使用空间</p></div> -->
            </div>
            <!-- 对标系统 -->
            <div class="system-num flex-x mb30">
                <label class="label"
                ><span style="color: red">*</span>对标系统</label
                >
                <div class="input-wrap" @click="data.bSystemTips = true">
                    <!--//$refs.systemPicker.show()-->
                    <!-- <input type="number" :value="sSelectSystemValue.value"> -->
                    <p>{{ data.sSelectSystemValue.value }}</p>
                    <div class="arrow-b"></div>
                </div>
            </div>
            <!-- 选择对标系统弹窗 -->
            <div
                class="system_tips"
                v-if="data.bSystemTips"
                @click.stop="data.bSystemTips = false"
            >
                <div class="system_tips_warp" @click.stop>
                    <div
                        class="system_tips_item"
                        v-for="(item, index) in data.arrSystemList"
                        :key="index"
                        @click="openSysValue(item,index)"
                    >
                        {{ item.value }}
                    </div>
                </div>
            </div>
            <!-- 房屋保温情况 -->
            <h4 class="tips mb30">家庭成员概况</h4>
            <!-- 成员人数 -->
            <div class="people-num flex-x mb30">
                <label class="label font-nor"
                ><span style="color: red">*</span>成员人数</label
                >
                <div class="input-wrap">
                    <input
                        type="number"
                        pattern="[0-9]*"
                        name=""
                        v-model="data.nFamiliesNum"
                    />
                    <span>人</span>
                </div>
            </div>
            <!-- 成员结构 -->
            <div class="membership flex-x mb30" v-if="data.oMemberFamilyInfo.items.length">
                <label class="label font-nor"
                ><span
                    style="color: red"
                    v-if="data.oMemberFamilyInfo.is_require === 1"
                >*</span
                >成员构成</label
                >
                <div class="tag">
                    <div
                        :class="[
                            'tag-item',
                            active(data.oMemberFamilyInfo, item) ? 'active' : '',
                        ]"
                        v-for="(item, index) in data.oMemberFamilyInfo.items"
                        :key="index"
                        @click="tagSelectChange(data.oMemberFamilyInfo, item)"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <!-- 居家休息 -->
            <div class="at-home mb30" v-if="data.oAtHomeInfo.items.length">
                <label class="label"
                ><span
                    style="color: red"
                    v-if="data.oAtHomeInfo.is_require === 1"
                >*</span
                >{{ data.oAtHomeInfo.name }}</label
                >
                <div class="tag">
                    <div
                        :class="[
                            'tag-item',
                            active(data.oAtHomeInfo, item) ? 'active' : '',
                        ]"
                        v-for="(item, index) in data.oAtHomeInfo.items"
                        :key="index"
                        @click="tagSelectChange(data.oAtHomeInfo, item)"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <!-- 个性需求 -->
            <div class="demand mb30" v-if="data.oIndividualNeedsInfo.items.length">
                <label class="label"
                ><span
                    style="color: red"
                    v-if="data.oIndividualNeedsInfo.is_require === 1"
                >*</span
                >{{ data.oIndividualNeedsInfo.name }}</label
                >
                <div class="tag">
                    <div
                        :class="[
                            'tag-item',
                            active(data.oIndividualNeedsInfo, item) ? 'active' : '',
                        ]"
                        v-for="(item, index) in data.oIndividualNeedsInfo.items"
                        :key="index"
                        @click="tagSelectChange(data.oIndividualNeedsInfo, item)"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <!-- 下一步按钮 -->
            <div class="btn">
                <button @click="submit()">下一步</button>
            </div>

            <!-- 楼层内容编辑弹窗 -->
            <div class="mask" v-if="data.editFloorContentPopupShow">
                <div class="floor-content-popup">
                    <div
                        class="floor-content-close"
                        @click.stop="data.editFloorContentPopupShow = false"
                    ></div>
                    <!-- 楼层 -->
                    <div class="floor-content-head">
                        <ul>
                            <li
                                :class="[
                                    data.arrEditFloorContent.activeIndex === index
                                        ? 'tab-active'
                                        : '',
                                    data.arrEditFloorContent.floor.length <= 3
                                        ? 'li-flex'
                                        : 'li-noflex',
                                ]"
                                v-for="(
                                    item, index
                                ) in data.arrEditFloorContent.floor"
                                :key="index"
                                @click.stop="
                                    data.arrEditFloorContent.activeIndex = index
                                "
                            >
                                {{ item.name }}
                            </li>
                        </ul>
                    </div>

                    <!-- 选择的空间 -->
                    <div class="scroll-wrap">
                        <div class="select-tags-content">
                            <div class="select-tags-title">已选空间</div>
                            <div class="select-tags-scroll">
                                <div
                                    class="select-tags-list"
                                    v-if="
                                        data.arrEditFloorContent.floor[
                                            data.arrEditFloorContent.activeIndex
                                        ].content.length !== 0
                                    "
                                >
                                    <div
                                        :class="[
                                            'select-tags',
                                            item.common_use === 0
                                                ? 'selected'
                                                : '',
                                        ]"
                                        v-for="(
                                            item, index
                                        ) in data.arrEditFloorContent.floor[
                                            data.arrEditFloorContent.activeIndex
                                        ].content"
                                        :key="index"
                                    >
                                        <span class="room-name"
                                        >{{
                                                item.name
                                            }}{{
                                                item.isNumber === 1
                                                    ? item.number
                                                    : ""
                                            }}</span
                                        >
                                        <input
                                            type="number"
                                            pattern="[0-9]*"
                                            name=""
                                            v-model="item.area"
                                        />
                                        <span class="unit">m²</span>
                                        <div
                                            class="close-icon"
                                            @click.stop="deleteTags(index)"
                                        ></div>
                                    </div>
                                </div>
                                <p class="no-data" v-else>请点击选择空间</p>
                            </div>
                            <div class="select-tags-tips">
                                备注：选择各区域名称，并输入面积
                            </div>
                        </div>
                        <div class="add-tags-content">
                            <div
                                class="cell"
                                v-for="(
                                    item, index
                                ) in data.arrEditFloorContent.allTagContent"
                                :key="index"
                            >
                                <div class="cell-head">{{ item.name }}</div>
                                <div class="cell-center">
                                    <div
                                        class="cell-item"
                                        v-for="(
                                            childItem, childIndex
                                        ) in item.allTags"
                                        :key="childIndex"
                                        @click="
                                            addTagschange(childItem, childIndex)
                                        "
                                    >
                                        {{ childItem.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="floor-content-btn">
                        <button @click.stop="floorContentPopupConfirm()">
                            确定
                        </button>
                    </div>
                </div>
            </div>

            <!-- 填写面积弹窗 -->
            <div class="mask" v-if="data.areaPopupShow">
                <div class="input-area-popup">
                    <div
                        class="input-area-close"
                        @click.stop="data.areaPopupShow = false"
                    ></div>
                    <div class="input-area-title">{{ data.oTags.name }}:</div>
                    <div class="input-area-content">
                        <div class="input-wrap">
                            <input
                                type="number"
                                pattern="[0-9]*"
                                name=""
                                v-model="data.areaPopupInputVal"
                            />
                            <span>m²</span>
                        </div>
                    </div>
                    <div class="input-area-btn">
                        <button @click.stop="areaPopupConfirm()">确定</button>
                    </div>
                </div>
            </div>
            <!-- 确认删除弹窗 -->
            <div class="mask" @touchmove.prevent v-if="data.bConfirmPopupShow">
                <div class="confirm-popup">
                    <div
                        class="popup-close"
                        @click.stop="data.bConfirmPopupShow = false"
                    ></div>
                    <div class="confirm-content">
                        <p>确认要删除当前空间?</p>
                    </div>
                    <div class="confirm-btn">
                        <button @click.stop="data.bConfirmPopupShow = false">
                            取消
                        </button>
                        <button @click.stop="popupConfirm()">确定</button>
                    </div>
                </div>
            </div>
            <!-- 删除楼层弹窗 -->
            <div class="mask" @touchmove.prevent v-if="data.bDelFloorPopupShow">
                <div class="public-popup">
                    <div
                        class="popup-close"
                        @click.stop="data.bDelFloorPopupShow = false"
                    ></div>
                    <div class="public-content">
                        <label class="label" style="padding-left: 10px"
                        >删除楼层</label
                        >
                        <div class="del-group">
                            <div
                                v-for="(item, index) in data.oHouseTypeInfo.tabList"
                                :key="index"
                                :class="[
                                    'del-tag-item',
                                    item.open ? 'active' : '',
                                ]"
                                @click="roomDel(index)"
                            >
                                {{ item.room | roomNumber }}
                            </div>
                        </div>
                    </div>
                    <div class="btn">
                        <button @click="floorDel()">确定</button>
                    </div>
                </div>
            </div>
            <!-- 地面楼层通用弹窗 -->
            <div class="mask" @touchmove.prevent v-if="data.bFloorPopupShow">
                <div class="public-popup">
                    <div
                        class="popup-close"
                        @click.stop="data.bFloorPopupShow = false"
                    ></div>
                    <div class="public-content">
                        <div
                            class="group"
                            v-for="(item, index) in data.arrFloorNumList"
                            :key="index"
                        >
                            <label class="label" style="padding-left: 10px">{{
                                    item.name
                                }}</label>
                            <div class="tag">
                                <div
                                    :class="[
                                        'tag-item',
                                        floorPopupActive(item, tagItem)
                                            ? 'active'
                                            : '',
                                    ]"
                                    v-for="(tagItem, tagIndex) in item.tags"
                                    :key="tagIndex"
                                    @click="floorPopupSlect(item, tagItem)"
                                >
                                    {{ tagItem.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="popup-tips">备注：点击标签，选择区域</div> -->
                    <div class="btn">
                        <button @click="floorPopupConfirm()">确定</button>
                    </div>
                </div>
            </div>

            <!-- 非频繁使用区域 -->
            <div class="mask" v-if="data.bNoOftenPopupShow">
                <div class="public-popup">
                    <div
                        class="popup-close"
                        @click.stop="data.bNoOftenPopupShow = false"
                    ></div>
                    <div class="popup-title">非频繁使用区域</div>
                    <div class="public-content scorll">
                        <div
                            class="group"
                            v-for="(item, index) in data.arrNoOftenTagList"
                            :key="index"
                        >
                            <div class="consent">
                                <label
                                    class="label"
                                    style="padding-left: 10px"
                                >{{ item.name }}</label
                                >
                                <div
                                    :class="
                                        item.openCheck
                                            ? 'onInputCheckbox'
                                            : 'inputCheckbox'
                                    "
                                    @click="getCheck(index)"
                                ></div>
                            </div>
                            <div class="tag" v-if="item.tags.length !== 0">
                                <div
                                    :class="[
                                        'tag-item',
                                        tagItem.openTags ? 'active' : '',
                                    ]"
                                    v-for="(tagItem, tagIndex) in item.tags"
                                    :key="tagIndex"
                                    @click="
                                        noOftenPopupSlect(
                                            item,
                                            index,
                                            tagItem,
                                            tagIndex
                                        )
                                    "
                                >
                                    {{
                                        tagItem.name
                                    }}{{
                                        tagItem.isNumber === 1
                                            ? tagItem.number
                                            : ""
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="popup-tips">备注：点击标签，选择区域</div> -->
                    <div class="btn">
                        <button @click="noOftenPopupConfirm()">确定</button>
                    </div>
                </div>
            </div>

            <!-- 选择地址 -->
            <el-select-address-map
                :nCityId.sync="data.nCityId"
                :arrCity="data.arrCity"
                :bShowMap.sync="data.bShowMap"
                :nLat.sync="data.nLat"
                :nLng.sync="data.nLng"
                :oAddress.sync="data.oAddress"
                :inputText="data.oAddress.name"
            ></el-select-address-map>

            <awesome-picker
                ref="systemPicker"
                :data="data.arrSystemList"
                :colorConfirm="data.oPicker.colorConfirm"
                @confirm="confirmSystemPicker"
            ></awesome-picker>
        </div>
    </div>
</template>
<script>
import oStorage from '@/libsV2/storage.js';
import oForm from "@/js/form.js";
import {getRoom, inputCheck, getWrong, tagsSortFun, editHouse, noOpenSlect} from "@/js/ant/basicinfov2.js";
import {objData} from "./data/objdata.js";
import elSelectAddressMap from "@/components/selectAddressMap/index.vue";
import detail from "@/js/detail";

export default {
    components: {
        elSelectAddressMap,
    },
    data() {
        return {
            data: objData(),
            /**
             * 计划书ID，如果有值，说明是编辑
             * @type {number | null}
             */
            plantId: null,
        };
    },

    created() {
        this.data.originalHeight =
            document.documentElement.clientHeight || document.body.clientHeight;

        window.addEventListener("resize", this.watchResize);

        this.$once("hook:beforeDestroy", () => {
            window.removeEventListener("resize", this.watchResize);
        });

        this.$store.commit("loadSwitch", true);

        // 编辑方案书ID
        const plantId = Number.parseInt(this.$route.query.plantId) || null;

        $init(() => {
            this.getTree();
            this.getConfigInfo();
            // 设置编辑状态
            this.$store.commit({type: 'proposal/CHANGE_EDIT_STATE', edit: plantId ? 1 : 0});
            // 编辑方案书
            plantId ? this.setPlantIdAndFetchInfo(plantId) : this.resetEdit();
        });

        // const addresInfo = JSON.parse(localStorage.getItem("addresInfo")) || {};
        const addresInfo = JSON.parse(oStorage.getStorage("addresInfo")) || {};
        this.data.nLat = addresInfo.latitude || null;
        this.data.nLng = addresInfo.longitude || null;

        if (this.$store.state.projectInfo.id) {
            this.data.oXnUserInfo = this.$store.state.projectInfo;
            this.data.nWindUid = this.$store.state.projectInfo.id;
            this.data.nCityId = this.$store.state.projectInfo.nCityId;
            this.data.oAddress.name = this.$store.state.projectInfo.address;
        }
    },
    computed: {
        // 页面的楼层内容
        arrTabContent() {
            if (this.data.oHouseTypeInfo.tabList[this.data.oHouseTypeInfo.activeIndex]) {
                // 只有一层时不显示层数
                // console.log(this.data.oHouseTypeInfo.tabList[
                //     this.data.oHouseTypeInfo.activeIndex
                //     ].content);
                return this.data.oHouseTypeInfo.tabList[
                    this.data.oHouseTypeInfo.activeIndex
                    ].content.filter((item) => item.tags.length !== 0);
            } else {
                return [];
            }
        },
        plantDetail() {
            return this.$store.state.proposal.plantDetail;
        },
        // 编辑状态 0 | 1
        isEdit() {
            return this.$store.state.proposal.isEdit
        }
    },
    watch: {
        // 锁定body滚动
        editFloorContentPopupShow(val) {
            if (val) {
                document.body.classList.add("dialog");
            } else {
                document.body.classList.remove("dialog");
            }
        },
        // 锁定body滚动
        bNoOftenPopupShow(val) {
            if (val) {
                document.body.classList.add("dialog");
            } else {
                document.body.classList.remove("dialog");
            }
        },
    },
    filters: {
        roomNumber(index) {
            return getRoom(index)
        },
    },
    methods: {
        /**
         * 重置编辑标识
         */
        resetEdit() {
            this.$store.commit({type: 'proposal/CHANGE_PLANT', plantDetail: {}});
            this.$store.commit({type: 'proposal/CHANGE_EDIT_HAS', info: {}})
        },
        /**
         * 报错方案书ID，请求详情
         * @param {number | null} plantId
         */
        setPlantIdAndFetchInfo(plantId) {
            this.plantId = plantId;
            this.$store.dispatch({
                type: 'proposal/fetchPlantDetail', payload: {report_id: this.plantId}
            }).then(() => {
                this.fullHisData();
            });
        },
        //呼出地图
        getShowMap() {
            this.data.bShowMap = true;

            if (this.data.nLat == null) {
                this.$toast("请允许获取地理位置");
            } else {
                this.data.bShowMap = true;
            }
        },
        // 输入框只允许输入数字和一个小数点  注：此方法只允许type = "text"类型的输入框
        NumberCheck(caet, num) {
            let data = inputCheck(caet, num);
            switch (data.caet) {
                case 0:
                    this.data.nArea = data.str;
                    break;
                case 1:
                    this.data.nFloor = data.str;
                    break;
            }
        },
        //非频繁使用空间全选
        getCheck(index, arrNoOftenTagList = this.data.arrNoOftenTagList) {
            // 参数 index： 选中的是第几层   arrNoOftenTagList： 非频繁使用空间选中的数组
            getWrong(index, arrNoOftenTagList);
            this.$forceUpdate();
        },
        openSysValue(item, index) {
            this.data.sSelectSystemValue = item;
            this.data.bSystemTips = false;
            this.data.nSelectSystemIndex = index;
        },
        // 监听软键盘弹起事件
        watchResize() {
            const resizeHeight =
                document.documentElement.clientHeight ||
                document.body.clientHeight;
            if (resizeHeight - 0 < this.data.originalHeight - 0) {
                //当软键盘弹起，在此处操作
                this.data.bShowBox = true;
            } else {
                //当软键盘收起，在此处操作
                this.data.bShowBox = false;
            }
        },

        // 确认选择对标系统
        confirmSystemPicker(res) {
            this.data.sSelectSystemValue = this.data.arrSystemList[res[0].index];
        },
        showCheckBox() {
            this.data.bShowCheckbox = true;
        },
        // 选中样式
        active(info, item) {
            return ~info.checked.findIndex((_) => _ === item.id);
        },
        // 选择标签
        tagSelectChange(info, item) {
            const active = info.checked.findIndex((_) => _ === item.id);
            if (info.is_fix === 1) {
                // 多选
                if (~active) {
                    info.checked.splice(active, 1);
                } else {
                    info.checked.push(item.id);
                }
            } else {
                // 单选
                if (~active) {
                    // info.checked.splice(active, 1)
                    return false;
                } else {
                    info.checked = [item.id];
                }
            }

            // 选择房屋类型的标签需改变户型概况
            if (info.id === 34 && info.checked.length === 1) {
                this.data.oHouseTypeInfo.activeIndex = 0;
                switch (item.type) {
                    case 1: // 平层
                        this.data.oHouseTypeInfo.tabList = [
                            {room: 1, name: "一层", content: [], open: false},
                        ];
                        break;
                    case 2: // 复式
                        this.data.oHouseTypeInfo.tabList = [
                            {room: 1, name: "一层", content: [], open: false},
                            {room: 2, name: "二层", content: [], open: false},
                        ];
                        break;
                    case 3: // 别墅
                        this.data.oHouseTypeInfo.tabList = [
                            {room: 1, name: "一层", content: [], open: false},
                            {room: 2, name: "二层", content: [], open: false},
                            {
                                room: -1,
                                name: "地下室一层",
                                content: [],
                                open: false,
                            },
                        ];
                        break;
                }
                this.data.nHuoseType = item.type;
            } else if (info.id === 34 && info.checked.length > 1) {
                this.$toast("房屋类型不能多选！");
            }
        },
        // 楼层切换
        tabSwitch(index) {
            this.data.oHouseTypeInfo.activeIndex = index;
        },

        // 编辑楼层内容
        editHouseTypeInfo() {
            editHouse(this.data.arrEditFloorContent, this.data.oHouseTypeInfo)
            this.data.editFloorContentPopupShow = true;
        },

        // 非频繁使用空间弹窗选中样式
        noOftenPopupActive(info, item) {
            return ~info.checked.findIndex(
                (_) => _.id === item.id && _.number === item.number
            );
        },
        // 非频繁使用空间弹窗选择事件
        noOftenPopupSlect(info, index, item, tagIndex) {
            noOpenSlect(info, index, item, tagIndex, this.data.arrNoOftenTagList)
            this.$forceUpdate();
        },

        // 非频繁使用空间弹窗确认
        noOftenPopupConfirm() {
            this.data.arrEditFloorContent.floor.forEach((floorItem) => {
                this.data.arrNoOftenTagList.forEach((item) => {
                    if (floorItem.room === item.room) {
                        floorItem.content.forEach((it) => {
                            const active = item.checked.findIndex(
                                (_) => _.id === it.id && _.number === it.number
                            );
                            it.common_use = ~active ? 0 : 1;
                        });
                    }
                });
            });

            this.data.oHouseTypeInfo.tabList.forEach((it) => {
                it.content = [
                    {
                        name: "室",
                        type: 0,
                        tags: [],
                    },
                    {
                        name: "厅",
                        type: 1,
                        tags: [],
                    },
                    {
                        name: "卫",
                        type: 2,
                        tags: [],
                    },
                    {
                        name: "厨",
                        type: 3,
                        tags: [],
                    },
                    {
                        name: "其他",
                        type: 4,
                        tags: [],
                    },
                ];
            });
            // 填充数据
            this.data.arrEditFloorContent.floor.forEach((item) => {
                this.data.oHouseTypeInfo.tabList.forEach((it) => {
                    if (item.room === it.room) {
                        item.content.forEach((childItem) => {
                            it.content.forEach((targetItem) => {
                                if (childItem.type === targetItem.type || childItem.room_type === targetItem.type) {
                                    targetItem.tags.push(childItem);
                                }
                            });
                        });
                    }
                });
            });
            this.data.editFloorContentPopupShow = false;
            this.data.bNoOftenPopupShow = false;
        },

        /*------------增加楼层弹窗 - 分界线-------------**/
        //删除楼层
        delFloor() {
            this.data.bDelFloorPopupShow = true;
        },
        //删除选择那个楼层
        roomDel(index) {
            this.data.oHouseTypeInfo.tabList[index].open =
                !this.data.oHouseTypeInfo.tabList[index].open;
        },
        //删除楼层
        floorDel() {
            //点亮那几个楼层
            let arrDelHouseRoom = this.data.oHouseTypeInfo.tabList.filter((it) => {
                return it.open == true;
            });
            //点亮楼层中是否有一楼
            let arrRooms = arrDelHouseRoom.filter((it) => {
                return it.room == 1;
            });
            if (arrDelHouseRoom.length == this.data.oHouseTypeInfo.tabList.length) {
                this.$toast("楼层请勿全部删除");
                return false;
            }
            if (arrRooms.length) {
                this.$toast("一楼请勿删除");
                return false;
            }
            let arrFushuRoom = [];
            let arrFloorRoom = this.data.oHouseTypeInfo.tabList.filter((it) => {
                return it.open == false;
            });
            this.data.oHouseTypeInfo.tabList = arrFloorRoom;
            this.data.oHouseTypeInfo.tabList.forEach((it, index) => {
                if (it.room > 0) {
                    it.room = index + 1;
                } else {
                    arrFushuRoom.push(it);
                    if (arrFushuRoom.length) {
                        if (arrFushuRoom.length[0] != -1) {
                            it.room = it.room + 1;
                        }
                    }
                }
            });
            this.data.bDelFloorPopupShow = false;
        },
        // 增加楼层
        addFloor() {
            if (this.data.oPropertyTypeInfo.checked.length === 0) {
                this.$toast("请选择房屋类型！");
                return false;
            }
            this.data.arrFloorNumList.forEach((item) => {
                item.checked = [];
            });
            this.data.bFloorPopupShow = true;
        },

        // 楼层弹窗选中样式
        floorPopupActive(info, item) {
            return ~info.checked.findIndex((_) => _ === item.room);
        },

        // 楼层弹窗选择事件
        floorPopupSlect(info, item) {
            const active = info.checked.findIndex((_) => _ === item.room);
            // 单选
            if (~active) {
                info.checked.splice(active, 1);
            } else {
                info.checked = [item.room];
            }
        },

        // 楼层弹窗确认按钮
        floorPopupConfirm() {

            // 校验是否选中标签
            if (this.data.arrFloorNumList[0].checked.length === 0) {
                this.$toast("请不要单独选择地下一层！");
                return false;
            }
            this.data.oHouseTypeInfo.tabList = [];
            this.data.oHouseTypeInfo.activeIndex = 0;
            const chnNumChar = {
                0: "零",
                1: "一",
                2: "二",
                3: "三",
                4: "四",
                5: "五",
                6: "六",
                7: "七",
                8: "八",
                9: "九",
            };
            this.data.arrFloorNumList.forEach((item) => {
                // 地面楼层
                if (item.type === 1 && item.checked.length !== 0) {
                    for (let i = 1; i <= item.checked[0]; i++) {
                        this.data.oHouseTypeInfo.tabList.push({
                            room: i,
                            name: `${chnNumChar[i]}层`,
                            content: [],
                            open: false,
                        });
                    }
                }
                // 地下室
                if (item.type === 2 && item.checked.length !== 0) {
                    switch (item.checked[0]) {
                        case -1:
                            this.data.oHouseTypeInfo.tabList.push({
                                room: -1,
                                name: "地下室一层",
                                content: [],
                                open: false,
                            });
                            break;
                        case -2:
                            this.data.oHouseTypeInfo.tabList.push({
                                room: -1,
                                name: "地下室一层",
                                content: [],
                                open: false,
                            });
                            this.data.oHouseTypeInfo.tabList.push({
                                room: -2,
                                name: "地下室二层",
                                content: [],
                                open: false,
                            });
                            break;
                    }
                }
            });

            this.data.bFloorPopupShow = false;
        },

        /*------------ 编辑楼层内容弹窗 - 分界线-------------**/
        // 编辑楼层
        editFloorContent(show = true) {
            this.data.arrEditFloorContent.activeIndex =
                this.data.oHouseTypeInfo.activeIndex;
            this.data.arrEditFloorContent.floor = [];
            this.data.arrEditFloorContent.allTagContent = [
                {
                    name: "室",
                    type: 0,
                    allTags: [],
                },
                {
                    name: "厅",
                    type: 1,
                    allTags: [],
                },
                {
                    name: "卫",
                    type: 2,
                    allTags: [],
                },
                {
                    name: "厨",
                    type: 3,
                    allTags: [],
                },
                {
                    name: "其他",
                    type: 4,
                    allTags: [],
                },
            ];
            let checked = [];
            this.data.oConfigInfo.room.forEach((item) => {
                this.data.arrEditFloorContent.allTagContent.forEach((_) => {
                    // 默认展示
                    if (_.type === item.type && item.is_default) {
                        checked.push({
                            ...item,
                            number: 1, // 增加编号
                            isNumber: 0, //是否展示标签序号
                            area: "", // 增加面积
                            common_use: 1, // 增加非频繁使用空间样式字段默认1， 0:代表是非频繁空间
                        });
                    }

                    // 全部
                    if (_.type === item.type) {
                        _.allTags.push({
                            ...item,
                            number: 1, // 增加编号
                            isNumber: 0, // 是否展示标签序号
                            area: "", // 增加面积
                            common_use: 1, // 增加非频繁使用空间样式字段默认1， 0:代表是非频繁空间
                        });
                    }
                });
            });

            this.data.oHouseTypeInfo.tabList.forEach((floorItem) => {
                const floor = JSON.parse(JSON.stringify(floorItem)); // 深拷贝
                floor.content = JSON.parse(JSON.stringify(checked)); // 深拷贝
                this.data.arrEditFloorContent.floor.push(floor);
            });

            this.data.editFloorContentPopupShow = show;
        },

        // 选择增加的标签
        addTagschange(item, index) {
            this.data.areaPopupInputVal = "";
            this.data.oTags = JSON.parse(JSON.stringify(item));
            this.data.areaPopupShow = true;
        },

        // 输入面积弹窗确定
        areaPopupConfirm() {
            if (!this.data.areaPopupInputVal) {
                this.$toast("请输入面积！");
                return false;
            }
            this.data.oTags.area = this.data.areaPopupInputVal;
            const index = this.data.arrEditFloorContent.activeIndex;
            this.data.arrEditFloorContent.floor[index].content.push(this.data.oTags);
            const tagsData = JSON.parse(
                JSON.stringify(this.data.arrEditFloorContent.floor[index].content)
            );
            this.data.arrEditFloorContent.floor[index].content = tagsSortFun(tagsData);
            this.data.areaPopupShow = false;
        },

        // 删除选择的标签
        deleteTags(index) {
            this.data.deleteIndex = index;
            this.data.bConfirmPopupShow = true;
        },

        // 确认弹窗 确认删除
        popupConfirm() {
            const floorIndex = this.data.arrEditFloorContent.activeIndex;
            this.data.arrEditFloorContent.floor[floorIndex].content.splice(
                this.data.deleteIndex,
                1
            );
            this.data.bConfirmPopupShow = false;
        },

        // 编辑楼层内容弹窗确认
        floorContentPopupConfirm() {
            let arrTips = [],
                areaTips = [];


            this.data.arrEditFloorContent.floor.forEach((item) => {
                if (item.content.length === 0) {
                    arrTips.push(item.name);
                } else {
                    item.content.forEach((_) => {
                        if (!_.area) {
                            areaTips.push(
                                `${item.name}的${_.name}的面积还未填写！`
                            );
                        }
                    });
                }
            });

            if (arrTips.length !== 0) {
                this.$toast(`${arrTips[0]}还未增加内容！`);
                return false;
            }

            if (areaTips.length !== 0) {
                this.$toast(`${areaTips[0]}`);
                return false;
            }

            // 开启选择非频繁使用空间弹窗
            this.data.arrNoOftenTagList = [];
            this.data.arrEditFloorContent.activeIndex =
                this.data.oHouseTypeInfo.activeIndex;
            this.data.arrEditFloorContent.floor.forEach((item) => {
                let tags = [],
                    checked = [],
                    roomType = [0, 1, 3];
                item.content.forEach((it) => {
                    it.openTags = false;
                    if (roomType.includes(it.type) || roomType.includes(it.room_type)) {
                        if (it.common_use === 0) {
                            checked.push({id: it.id || it.room_id, number: it.number});
                        }
                        tags.push(it);
                    }
                });
                tags.forEach((ia) => {
                    checked.forEach((idc) => {
                        if ((ia.id == idc.id || ia.room_id == idc.id) && ia.number == idc.number) {
                            ia.openTags = true;
                        }
                    });
                });
                let arropenTages = tags.filter((is) => {
                    return is.openTags == true;
                });
                let bOpenCheck = false;
                if (arropenTages.length == tags.length) {
                    bOpenCheck = true;
                }
                this.data.arrNoOftenTagList.push({
                    room: item.room,
                    openCheck: bOpenCheck,
                    name: item.name,
                    checked: checked,
                    tags: tags,
                });
            });
            this.data.bNoOftenPopupShow = true;
        },


        // 获取地址三级联动数据
        getTree() {
            oForm.getTree().then((res) => {
                let arrTree = res.data.data.result;
                let arrProvince = arrTree[0];
                arrProvince.forEach((it) => {
                    it["value"] = it.name;
                    if (arrTree[it.id].length) {
                        it["children"] = arrTree[it.id];
                        it.children.forEach((sit) => {
                            sit["value"] = sit.name;
                            // sit['children'] = arrTree[sit.id]
                        });
                    }
                });
                arrProvince.splice(0, 1);
                this.data.arrCity = arrProvince;
            });
        },

        // 获取配置信息
        async getConfigInfo() {
            const resultData = await oForm.getConfigInfo({
                city_id: this.data.nCityId,
            });
            if (resultData.data.error === 0) {
                this.data.oConfigInfo = resultData.data.data.result;
                // compare_id

                this.data.arrSystemList = this.data.oConfigInfo.benchmarke.map((item) => {
                    return {value: item.name, id: item.id};
                });
                // 配置数据分类、填充
                this.data.oConfigInfo.tags.forEach((item) => {
                    if (item.id === this.data.oGenderInfo.id) {
                        this.data.oGenderInfo = {
                            checked: [],
                            ...item,
                        };
                    }
                    if (item.id === this.data.oRenovationInfo.id) {
                        this.data.oRenovationInfo = {
                            checked: [],
                            ...item,
                        };
                    }
                    if (item.id === this.data.oPropertyTypeInfo.id) {
                        item.items = item.items.map((_) => {
                            switch (_.name) {
                                case "平层":
                                    _.type = 1;
                                    break;
                                case "复式":
                                    _.type = 2;
                                    break;
                                case "别墅":
                                    _.type = 3;
                                    break;
                            }
                            return {..._};
                        });
                        this.data.oPropertyTypeInfo = {
                            checked: [],
                            ...item,
                        };
                    }
                    if (item.id === this.data.oMemberFamilyInfo.id) {
                        this.data.oMemberFamilyInfo = {
                            checked: [],
                            ...item,
                        };
                    }
                    if (item.id === this.data.oAtHomeInfo.id) {
                        this.data.oAtHomeInfo = {
                            checked: [],
                            ...item,
                        };
                    }
                    if (item.id === this.data.oIndividualNeedsInfo.id) {
                        this.data.oIndividualNeedsInfo = {
                            checked: [],
                            ...item,
                        };
                    }
                });
            } else {
                this.$toast(resultData.data.msg);
            }
            this.$store.commit("loadSwitch", false);
        },
        /**
         * 填充历史信息
         */
        fullHisData() {
            const {
                address,
                area,
                floor,
                warm_keep,
                warm_length,
                house_type,
                sex,
                sub,
                compare_id,
                config_num,
                personTag,
                timeTag,
                demandTag
            } = this.$store.getters["proposal/basicInfo"]();
            const {
                oExteriorInfo,
                oMemberFamilyInfo,
                oHeatInsulationInfo,
                oPropertyTypeInfo,
                oGenderInfo,
                arrSystemList,
                oAtHomeInfo,
                oIndividualNeedsInfo
            } = this.data;
            this.data.oAddress.name = address;
            this.data.nArea = area;
            this.data.nFloor = floor;
            // 外墙保温
            this.tagSelectChange(oExteriorInfo, oExteriorInfo.items.find(i => i.id === warm_keep));
            // 双层隔热窗
            this.tagSelectChange(oHeatInsulationInfo, oHeatInsulationInfo.items.find(i => i.id === warm_length));
            // 房屋类型
            this.tagSelectChange(oPropertyTypeInfo, oPropertyTypeInfo.items.find(i => i.name === house_type))
            // 性别
            this.tagSelectChange(oGenderInfo, oGenderInfo.items.find(i => i.name === sex));
            // 楼层数据
            const roomsType = sub.map(i => i.room); // 楼层数量
            this.data.arrFloorNumList = this.data.arrFloorNumList.map(i => {
                switch (i.type) {
                    // 地上
                    case 1:
                        i.checked = [Math.max(...roomsType)];
                        break;
                    // 地下
                    case 2:
                        i.checked = [Math.min(...roomsType)];
                        break;
                }
                return i;
            })
            this.floorPopupConfirm(); // 模拟用户点击楼层保存


            // 填充房间信息
            this.editFloorContent(false);
            this.data.arrEditFloorContent.floor = this.data.arrEditFloorContent.floor.map(i => {
                const {rooms_choose, rooms, rooms_init} = sub.find(item => i.room === item.room);
                // rooms_choose 是基本信息房间，一点要放最后面
                const allRoom = [...rooms, ...rooms_init, ...rooms_choose];
                const roomMap = new Map();
                allRoom.forEach(room => {
                    roomMap.set(room.name, room);
                });
                i.content = [];
                // 把所有房间信息取出来
                roomMap.forEach(room => i.content.push(room));
                return i;
            })
            this.floorContentPopupConfirm();
            this.noOftenPopupConfirm();

            // 选择对标
            this.openSysValue(arrSystemList.find(i => i.id === compare_id), arrSystemList.findIndex(i => i.id === compare_id));
            // 家庭人员
            this.data.nFamiliesNum = config_num;
            // 家人情况
            personTag.forEach(tag => {
                const item = oMemberFamilyInfo.items.find(i => i.name === tag);
                item && this.tagSelectChange(oMemberFamilyInfo, item)
            });
            // 时间情况
            timeTag.forEach(tag => {
                const item = oAtHomeInfo.items.find(i => i.name === tag);
                item && this.tagSelectChange(oAtHomeInfo, item)
            });
            // 个性需求
            demandTag.forEach(tag => {
                const item = oIndividualNeedsInfo.items.find(i => i.name === tag);
                item && this.tagSelectChange(oIndividualNeedsInfo, item)
            });

            // console.log(demandTag)
        },

        // 提交信息
        async submit() {

            if (!this.data.oAddress.name) {
                this.$toast("请输入详细地址");
                return false;
            }
            if (
                this.data.oRenovationInfo.checked.length === 0 &&
                this.data.oRenovationInfo.is_require === 1
            ) {
                this.$toast("请选择装修情况");
                return false;
            }
            if (
                this.data.oGenderInfo.checked.length === 0 &&
                this.data.oGenderInfo.is_require === 1
            ) {
                this.$toast("请选择用户性别");
                return false;
            }
            if (!this.data.nArea) {
                this.$toast("请输入房屋面积");
                return false;
            }
            if (!this.data.nFloor) {
                this.$toast("请输入房屋层高");
                return false;
            }
            if (
                this.data.oExteriorInfo.checked.length === 0 &&
                this.data.oExteriorInfo.is_require === 1
            ) {
                this.$toast("请选择外墙保温情况");
                return false;
            }
            if (
                this.data.oHeatInsulationInfo.checked.length === 0 &&
                this.data.oHeatInsulationInfo.is_require === 1
            ) {
                this.$toast("请选择双层隔热窗情况");
                return false;
            }
            if (
                this.data.oPropertyTypeInfo.checked.length === 0 &&
                this.data.oPropertyTypeInfo.is_require === 1
            ) {
                this.$toast("请选择房屋类型");
                return false;
            }
            let arrTips = [];
            if (this.data.oHouseTypeInfo.tabList.length === 0) {
                this.$toast("请选择楼层");
                return false;
            } else {
                this.data.oHouseTypeInfo.tabList.forEach((item) => {
                    if (item.content.length === 0) {
                        arrTips.push(item.name);
                    }
                });
            }
            if (arrTips.length !== 0) {
                this.$toast(`请先添加${arrTips[0]}楼层的内容！`);
                return false;
            }
            if (!this.data.sSelectSystemValue.id) {
                this.$toast("请选择对标系统");
                return false;
            }
            if (!this.data.nFamiliesNum) {
                this.$toast("请输入成员人数");
                return false;
            }
            if (
                this.data.oMemberFamilyInfo.checked.length === 0 &&
                this.data.oMemberFamilyInfo.is_require === 1
            ) {
                this.$toast("请选择成员构成");
                return false;
            }
            if (
                this.data.oAtHomeInfo.checked.length === 0 &&
                this.data.oAtHomeInfo.is_require === 1
            ) {
                this.$toast("请选择居家作息");
                return false;
            }
            if (
                this.data.oIndividualNeedsInfo.checked.length === 0 &&
                this.data.oIndividualNeedsInfo.is_require === 1
            ) {
                this.$toast("请选择个性需求");
                return false;
            }

            // const editId = this.$store.state.proposal.oldDetailInfo.edit_id;

            const requestData = this.getFormRequestData();


            this.$store.commit("loadSwitch", true);


            this.$store.commit("loadSwitch", false);

            console.log(this.plantId)

            if (this.plantId) {
                const checkEditInfo = this.checkEditEd();
                console.log(checkEditInfo)

                // 有差异的话，创建一个新的草稿
                if (checkEditInfo) {
                    requestData.report_id = this.plantId;
                    requestData.is_edit = 1;
                    const {data: {data: {result: {id}}}} = await oForm.reportAdd(requestData);
                    this.$store.commit({type: 'proposal/CHANGE_EDIT_STATE', edit: 2});
                    this.$store.commit("updateAntReportId", id,);
                } else {
                    this.$store.commit(
                        "updateAntReportId",
                        this.plantId,
                    );
                }


                this.$router.replace("/ant/end/v2");
            } else {
                const resultData = await oForm.reportAdd(requestData);
                if (resultData.data.error === 0) {
                    this.$router.replace("/ant/end/v2");
                } else {
                    this.$toast(resultData.data.msg);
                }


            }
        },
        // 获取请求表单内容
        getFormRequestData() {

            const config_ids = [
                ...this.data.oRenovationInfo.checked,
                ...this.data.oGenderInfo.checked,
                ...this.data.oPropertyTypeInfo.checked,
                ...this.data.oMemberFamilyInfo.checked,
                ...this.data.oAtHomeInfo.checked,
                ...this.data.oIndividualNeedsInfo.checked,
            ].join(",");
            const rooms = this.data.oHouseTypeInfo.tabList.map((item) => {
                const roomsTags = item.content.reduce(
                    (prev, cur) => {
                        const tags = cur.tags.map((_) => {
                            if (_.isNumber === 1) {
                                return {
                                    name: `${_.name}${_.number}`,
                                    room_id: this.plantId ? _.room_id : _.id,
                                    area: _.area,
                                    common_use: _.common_use,
                                };
                            } else {
                                return {
                                    name: _.name,
                                    room_id: this.plantId ? _.room_id : _.id,
                                    area: _.area,
                                    common_use: _.common_use,
                                };
                            }
                        });
                        return [...prev, ...tags];
                    },
                    []
                );
                return {
                    room: item.room,
                    rooms: roomsTags,
                };
            });

            return {
                wind_uid: this.data.nWindUid || this.plantDetail.wind_user_id || 0,
                uname: this.data.oXnUserInfo.name || this.plantDetail.uname,
                uphone: this.data.oXnUserInfo.phone || this.plantDetail.phone,
                latitude: this.data.nLat || this.plantDetail.latitude,
                longitude: this.data.nLng || this.plantDetail.longitude,
                city_id: this.data.nCityId || this.plantDetail.city_id,
                floor: this.data.nFloor,
                warm_keep: this.data.oExteriorInfo.checked[0],
                warm_length: this.data.oHeatInsulationInfo.checked[0],
                address: this.data.oAddress.name,
                compare_id: this.data.sSelectSystemValue.id,
                area: this.data.nArea,
                config_ids: config_ids,
                config_num: this.data.nFamiliesNum,
                rooms: JSON.stringify(rooms),
                // report_id: !!editId ? this.plantId : editId,
                // is_edit: !!editId ? 1 : 0,
            };

        },
        /**
         * 校验是否编辑过内容
         * @returns {boolean}
         */
        checkEditEd() {
            this.$store.commit('loadSwitch', true);
            const targetData = JSON.stringify(this.getFormRequestData());
            this.fullHisData();
            this.fullHisData();
            const hisData = JSON.stringify(this.getFormRequestData());
            this.$store.commit('loadSwitch', false);
            return targetData === hisData ? null : JSON.parse(targetData);
        }

    },

};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
